<template>
    <svg width="57" height="56" viewBox="0 0 57 56" fill="inherit" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" width="56" height="56" rx="28" fill="var(--player-contrast)"/>
        <rect x="23.1667" y="20.3335" width="2.33333" height="16.3333" rx="1.16667" fill="var(--player-accent)"/>
        <rect x="32.5" y="20.3335" width="2.33333" height="16.3333" rx="1.16667" fill="var(--player-accent)"/>
    </svg>
</template>
